import { Factor } from "types/factor/factor";

const getPhoneNumber = (factor: Factor): string =>
  factor.profile?.phoneNumber ?? "";

export default getPhoneNumber;
